import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const AdBanner = ({ placement }) => {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get(`/ads?placement=${placement}`).then(r => setAds(r.data)).catch(() => {});
  }, [placement]);

  useEffect(() => {
    if (ads.length > 1) {
      const t = setInterval(() => setIdx(i => (i + 1) % ads.length), 6000);
      return () => clearInterval(t);
    }
  }, [ads.length]);

  if (ads.length === 0) return null;
  const ad = ads[idx];

  const onClick = () => {
    api.post(`/ads/${ad.id}/click`).catch(() => {});
  };

  const isHero = placement === "homepage_hero";

  return (
    <Link
      to={ad.cta_url || `/restaurants/${ad.restaurant?.slug}`}
      onClick={onClick}
      data-testid={`ad-banner-${placement}`}
      className={`block relative overflow-hidden rounded-2xl border border-border group ${isHero ? "h-48 md:h-64" : "h-32 md:h-40"}`}
    >
      <img src={ad.image_url} alt={ad.headline || ad.restaurant?.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent" />
      <div className="absolute inset-0 p-5 md:p-8 flex flex-col justify-between text-white">
        <span className="self-start text-[10px] tracking-[0.2em] uppercase font-bold bg-white/20 backdrop-blur px-2 py-1 rounded-full">Sponsored</span>
        <div>
          <h3 className={`font-heading font-black leading-tight ${isHero ? "text-2xl md:text-4xl" : "text-lg md:text-2xl"}`}>
            {ad.headline || ad.restaurant?.name}
          </h3>
          <div className="mt-2 inline-flex items-center gap-1 text-xs md:text-sm font-semibold bg-primary px-3 py-1.5 rounded-full">
            {ad.cta_text || "Lihat Restoran"} →
          </div>
        </div>
      </div>
    </Link>
  );
};

export default AdBanner;
